// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3o-OB","row":"Node_row__1r7Sr","label":"Node_label__1opG4","footer":"Node_footer__26gg7"};